import { T_UserBlockchainData } from '@/ts/types/T_UserBlockchainData';

/**
 * Gets a blockchain prediction value by index
 * @param blockchainData - The user blockchain data
 * @param index - The index of the value to retrieve (0: totalRewardsAmountDecimal, 1: totalPredictionLossesAmountDecimal, 2: totalUnclaimedRewardsAmountDecimal)
 * @param isEmptyState - Whether the state is empty
 * @returns The parsed numeric value or 0
 */
export function getBlockchainPredictionValue(
  blockchainData: T_UserBlockchainData | undefined,
  index: number,
  isEmptyState: boolean
): number {
  if (!blockchainData || isEmptyState) return 0;

  // For index 1 (total missed), calculate: totalPredictionLossesAmountDecimal - totalPendingPredictionAmountDecimal - totalCanceledAmountDecimal
  if (index === 1) {
    const totalLosses = parseFloat(
      blockchainData.totalPredictionLossesAmountDecimal || '0'
    );
    const totalPending = parseFloat(
      blockchainData.totalPendingPredictionAmountDecimal || '0'
    );
    const totalCanceled = parseFloat(
      blockchainData.totalCanceledAmountDecimal || '0'
    );
    const calculated = totalLosses - totalPending - totalCanceled;
    return isNaN(calculated) ? 0 : Math.max(0, calculated);
  }

  const valueMap: Record<number, string | undefined> = {
    0: blockchainData.totalRewardsAmountDecimal,
    1: blockchainData.totalPredictionLossesAmountDecimal, // This is now calculated above
    2: blockchainData.totalUnclaimedRewardsAmountDecimal
  };

  const value = valueMap[index];
  if (!value) return 0;

  const parsed = parseFloat(value);
  return isNaN(parsed) ? 0 : parsed;
}
